export default {
      id: "image-download-failed-usage",
      viewBox: "0 0 179 120",
      url: __webpack_public_path__ + "icons.svg#image-download-failed",
      toString: function () {
        return this.url;
      }
    }